// src/redux/notificationApi.js
import { apiSlice } from "./apiSlice";

export const notificationApi = apiSlice.injectEndpoints({
    endpoints: (build) => ({
        // 알림 리스트 조회 – readYn 파라미터를 선택적으로 전달할 수 있음
        getNotificationList: build.query({
            query: (readYn) => ({
                url: "/api/user/notification/v1",
                method: "get",
                params: { read_yn: readYn }, // readYn 값: "Y" 또는 "N"
                headers: { token: true },
            }),
            providesTags: ["Notification"],
        }),
        // 알림 상세 조회
        getNotificationById: build.query({
            query: (notificationId) => ({
                url: `/api/user/notification/v1/${notificationId}`,
                method: "get",
                headers: { token: true },
            }),
            providesTags: (result, error, arg) => [{ type: "Notification", id: arg }],
        }),
    }),
});

export const { useGetNotificationListQuery, useGetNotificationByIdQuery } = notificationApi;
